<template>
    <div class="pragmatic-jackpot">
        <h3>
            <img :src="$store.state.main.cdn_url + '/providers/pragmaticplay.png'" width="75">
            JACKPOT</h3>
        <div class="jackpot-content">
            <div class="item" v-if="key != 'name'" :style="'background-image: url(' + $store.state.main.cdn_url + '/providers/pragmatic-jackpot.png?2)'" :class="'jackpot_tier_' + item.tier" v-for="(item,key) in jackpot" :key="key">
                <div class="title">
                    <slot v-if="item.tier == 0">MINOR</slot>
                    <slot v-if="item.tier == 1">MAJOR</slot>
                    <slot v-if="item.tier == 2">MEGA</slot>
                    <slot v-if="item.tier == 3">GRAND</slot>
                </div>
                <b>
                    <IOdometer
                    :value="parseFloat(item.amount)"
                    />  
                </b>
            </div>
        </div>
    </div>
</template>

<script>
    import IOdometer from 'vue-odometer';
    import 'odometer/themes/odometer-theme-default.css';
    export default{
        components: {
        IOdometer
        },
        computed:{
            jackpot(){
                return this.$store.getters['getJackpots'].pragmaticplay.data.jackpots[0];
            },
        },
    }
</script>

<style lang="scss">
    .pragmatic-jackpot{
        border-radius: 10px;
        margin-bottom: 10px;
        background: linear-gradient(90deg, rgba(0, 0, 0, 0) 0%, #ffffff12 48%, rgba(0, 0, 0, 0) 100%);
        padding: 15px 0;
        h3{
            text-align: center;
            font-size: 18px;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0px;
            margin: 0px;
            img{
                margin-right: 10px;
                width: 120px;
                margin-top: -10px;
            }
        }
        .jackpot-content{
            display: flex;
            margin: 0 -1%;
            .item{
                width: 100%;
                height: 68px;
                background-size: 100%;
                margin: 1%;
                position: relative;
                &.jackpot_tier_0{
                    background-position: 0 -138px;
                }
                &.jackpot_tier_2{
                    background-position: 0 -207px;
                }
                &.jackpot_tier_1{
                    background-position: 0 0px;
                }
                &.jackpot_tier_3{
                    background-position: 0 -68px;
                }
                .title{
                    font-size: 14px;
                    font-weight: 900;
                    position: absolute;
                    left: 0px;
                    top: 5px;
                    width: 25%;
                    text-align: center;
                }
                b{
                    position: absolute;
                    right: 55px;
                    font-weight: 900;
                    font-size: 25px;
                    top: 50%;
                    transform: translateY(-50%);
                }
            }
        }
    }
    #app.mobile{
        
    .pragmatic-jackpot{
            margin-bottom: 0px;
            .jackpot-content{
                width: 360px;
                flex-wrap: wrap;
                margin: 0 auto;
                .item{
                    height: 37px;
                    background-size: 100%;
                    margin: 2%;
                    position: relative;
                    width: 165px;
                    &.jackpot_tier_0{
                        background-position: 0 -74px;
                    }
                    &.jackpot_tier_2{
                        background-position: 0 -112px;
                    }
                    &.jackpot_tier_1{
                        background-position: 0 0px;
                    }
                    &.jackpot_tier_3{
                        background-position: 0 -37px;
                    }
                    span{
                        top: 3px;
                        font-size: 8px;
                    }
                    b{
                        right: 30px;
                        font-size: 14px;
                        top: 50%;
                    }
                }
                h3{
                }
            }
        }
    }
</style>